import {useRef} from 'react';
import useIsomorphicEffect from 'src/internal/useIsomorphicEffect';

/**
 *
 * @see https://sail.stripe.me/apis/react/usePrevious
 */
export default function usePrevious<T>(
  /** The value to be remember for the next execution. */
  value: T,
): T | undefined {
  const valueRef = useRef<T | undefined>(undefined);

  useIsomorphicEffect(() => {
    valueRef.current = value;
  }, [value]);

  // eslint-disable-next-line react-hooks/refs
  return valueRef.current;
}
